import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import {
    getParamAPI
} from '@/assets/axios/commAxios.js'
import {
    Guuid,
    getDGCopy
} from '@/assets/js/basis'

export default new Vuex.Store({
    state: {
        user: {},
        showPages: 0,
        //副导航
        subTileList: [],
        //父级路由地址
        FaPath: '',
        //顶部导航
        modelType: 0,
        //顶部跳转router
        modelRoute: ['/dataSource', '/stencilList', '/teamSharing', '/findUser', '/benefitList'],
        //0 多维分析 1 设计器
        dpType: 0,
        //多维分析 //项目效益指标评价
        viewDP: {
            //当前图表
            nowChart: {
                type: '',
                name: '',
                //公共参数
                comConfig: {
                    valLength: 50,
                    //图表名称
                    chartName: '',
                    //0 普通 1 圆形 2 其他
                    gridType: 0,
                    //普通
                    grid: {
                        top: 15,
                        bottom: 5,
                        left: 5,
                        right: 5,
                    },
                    //圆
                    circle: {
                        top: 50,
                        left: 50
                    },
                    //颜色组
                    colorIndex: 0,
                    zdy: {
                        chartsTask1: false,
                        chartsUpdateFrequency1: 0,
                        chartsAnimationDuration: 0,
                        chartsTask2: false,
                        chartsUpdateFrequency2: 0,
                    },
                },
                dataPage: 1, //当前多维分析所在的页面 1数据配置,2对比分析,3数据透视;
            },
            //缓冲
            load: false,
            //暂无数据
            noData: true,
            //图表
            chart: {
                //自定义参数
                setting: {
                    //维度参数
                    wdList: [],
                    //度量参数
                    dlList: [],
                    //筛选参数
                    sxList: [],
                    //下钻参数
                    xzList: [],
                    //参数
                    params: {}
                },
                //图表配置
                option: {},
                //保存的整体对象
                initOrig: {},
                //自定义图表
                comp: {
                    show: false,
                    component: null
                },
                //接口返回数据
                data: {},
            },
            //dom元素地址
            dom: null,
            //默认全局维度参数
            comWDConfig: {
                order: '默认',
                alias: '',
                calc: '默认'
            },
            //默认全局度量参数
            comDLConfig: {
                order: '默认',
                alias: '',
                calc: '默认'
            },
            //默认全局筛选参数
            comSXConfig: {
                //空值
                nullVal: 1,
                /* - - - - - - - 日期 - - - - - -*/
                //是否进行过 日期 接口逻辑
                datebool: false,
                //时间筛选
                timDate: [],
                //离散时间
                disDateType: '默认',
                //离散时间 选中的数组
                disDateCheck: [],
                //离散时间 总的数组
                disDateFil: [{
                    type: '默认',
                    values: []
                }],
                /* - - - - - - - 字符 - - - - - -*/
                //是否进行过 字符串 接口逻辑
                strbool: false,
                //常规筛选 总的数组
                convStrFilList: [],
                //常规筛选 选中的数组
                convStrCheck: [],
                //条件筛选
                ditStr: [],
                /* - - - - - - - 数字 - - - - - -*/
                //是否进行过 数字 接口逻辑
                numbool: false,
                //范围筛选
                ranNum: [0, 100],
                //范围筛选 起始/终点
                ranNumSTEN: {
                    start: 0,
                    end: 100
                },
                //条件筛选
                ditNum: [],
            },
        },
        //多维分析 //项目效益指标评价
        benefit: {
            //当前图表
            nowChart: {
                type: '',
                name: '',
                //公共参数
                comConfig: {
                    valLength: 50,
                    //图表名称
                    chartName: '',
                    //0 普通 1 圆形 2 其他
                    gridType: 0,
                    //普通
                    grid: {
                        top: 15,
                        bottom: 5,
                        left: 5,
                        right: 5,
                    },
                    //圆
                    circle: {
                        top: 50,
                        left: 50
                    },
                    //颜色组
                    colorIndex: 0,
                    zdy: {
                        chartsTask1: false,
                        chartsUpdateFrequency1: 0,
                        chartsAnimationDuration: 0,
                        chartsTask2: false,
                        chartsUpdateFrequency2: 0,
                    }
                },
            },
            //缓冲
            load: false,
            //暂无数据
            noData: true,
            //图表
            chart: {
                //自定义参数
                setting: {
                    //维度参数
                    wdList: [],
                    //度量参数
                    dlList: [],
                    //筛选参数
                    sxList: [],
                    //下钻参数
                    xzList: [],
                    //参数
                    params: {}
                },
                //图表配置
                option: {},
                //保存的整体对象
                initOrig: {},
                //自定义图表
                comp: {
                    show: false,
                    component: null
                },
                //接口返回数据
                data: {},
            },
            //dom元素地址
            dom: null,
            //默认全局维度参数
            comWDConfig: {
                order: '默认',
                alias: '',
                calc: '默认'
            },
            //默认全局度量参数
            comDLConfig: {
                order: '默认',
                alias: '',
                calc: '默认'
            },
            //默认全局筛选参数
            comSXConfig: {
                //空值
                nullVal: 1,
                /* - - - - - - - 日期 - - - - - -*/
                //是否进行过 日期 接口逻辑
                datebool: false,
                //时间筛选
                timDate: [],
                //离散时间
                disDateType: '默认',
                //离散时间 选中的数组
                disDateCheck: [],
                //离散时间 总的数组
                disDateFil: [{
                    type: '默认',
                    values: []
                }],
                /* - - - - - - - 字符 - - - - - -*/
                //是否进行过 字符串 接口逻辑
                strbool: false,
                //常规筛选 总的数组
                convStrFilList: [],
                //常规筛选 选中的数组
                convStrCheck: [],
                //条件筛选
                ditStr: [],
                /* - - - - - - - 数字 - - - - - -*/
                //是否进行过 数字 接口逻辑
                numbool: false,
                //范围筛选
                ranNum: [0, 100],
                //范围筛选 起始/终点
                ranNumSTEN: {
                    start: 0,
                    end: 100
                },
                //条件筛选
                ditNum: [],
            },
        },
        //设计器
        designer: {
            //页面宽高
            pageSize: {
                width: 0,
                height: 0
            },
            //默认值
            defaultVal: {
                //公共配置 赋值用 【同多维分析】
                comConfig: {
                    valLength: 50,
                    //图表名称
                    chartName: '',
                    //0 普通 1 圆形 2 其他
                    gridType: 0,
                    //普通
                    grid: {
                        top: 15,
                        bottom: 5,
                        left: 5,
                        right: 5,
                    },
                    //圆
                    circle: {
                        top: 50,
                        left: 50
                    },
                    //颜色组
                    colorIndex: 0,
                    //边框
                    border: {
                        show: true,
                        index: '自定义',
                        width: 1,
                        radius: 0,
                        style: 'solid',
                        color: '#13B5B1'
                    },
                    zdy: {
                        chartsTask1: false,
                        chartsUpdateFrequency1: 0,
                        chartsAnimationDuration: 0,
                        chartsTask2: false,
                        chartsUpdateFrequency2: 0,
                    }
                },
                //自定义json数据
                JSONData: {
                    //0 api 1 静态
                    type: 1,
                    valData: '',
                    //默认的JSON
                    oldValData: '',
                    apiData: {
                        url: '',
                        type: 'get',
                        postType: 0,
                        post: '',
                        headerShow: false,
                        header: '',
                    },
                    params: {},
                },
                //页面用的参数
                pageParam: {
                    //背景
                    back: {
                        index: 0,
                        //颜色遮罩
                        modalBackColor: 'rgba(0,0,0,.7)',
                        isOutIn: 0,
                        outLinkText: "", //外部网址链接
                        rotationID: "", //轮播大屏id
                        rotationTime: 0, //轮播时间
                        checkedVal1: 0, //大屏轮播是否开启
                    },
                }
            },
            //选中的图表
            nowChart: {
                //某种类型
                opType: '',
                //单个图表组件配置
                comPonent: {
                    //配置组件
                    component: [],
                    //维度组件
                    wdComponent: null,
                    //度量组件
                    dlComponent: null,
                    //json组件
                    jsonComponent: null,
                    //维度默认参数
                    wdParams: {},
                    //度量默认参数
                    dlParams: {},
                },
                //是否展示某个配置项
                config: {
                    //维度配置项
                    wdConfig: false,
                    //度量配置项
                    dlConfig: false,
                    //json配置项
                    JSONConfig: false,
                    //公共配置项
                    comConfig: false,
                    //公共配置项
                    borderConfig: false,
                },
                //实际 用的 公共参数
                comParam: {
                    //自定义json数据
                    JSONData: {},
                },
                //页面用的参数
                pageParam: {
                    //背景
                    back: {
                        index: 0,
                        //遮罩颜色
                        modalBackColor: 'rgba(0,0,0,0.3)',
                        isOutIn: 0,
                        outLinkText: "", //外部网址链接
                        rotationID: "", //轮播大屏id
                        rotationTime: 0, //轮播时间
                        checkedVal1: 0, //大屏轮播是否开启
                    },
                },
            },
            //修改的公共参数
            updParam: {
                //自定义json数据
                JSONData: {},
            },
            //当前选中的某一个图表
            chart: {
                //id
                id: '',
                //图表类型
                type: '',
                //拖动框的类型 0 基本图表 1 多维分析 2 元素
                dragType: '',
                //图表类型名称
                name: '',
                //自定义参数
                setting: {
                    //维度参数
                    wdList: [],
                    //度量参数
                    dlList: [],
                    //维度样式参数
                    wdStyParam: [],
                    //度量样式参数
                    dlStyParam: [],
                    //筛选参数
                    sxList: [],
                    //下钻参数
                    xzList: [],
                    //参数
                    params: {},
                },
                //保存的整体对象
                initOrig: {},
                //图表配置
                option: {},
                //dom元素地址
                domId: null,
                //接口返回数据
                data: {},
                //公共参数
                comConfig: {}, //这就是源头
            },
            //当前模版的大屏ID
            groupDpList: [],
            //图表数组
            chartList: []
        },
        //消息
        news: {
            show: false
        },
    },
    mutations: {},
    actions: {
        // - - - - - - - - - - - - - - - - - - - - - - 多维分析 - - - - - - - - - - - - - - - - - - - - - - - - -//

        //多维分析渲染
        async viewDPRender({
            commit,
            state
        }) {
            let stateChart = state.viewDP.chart;
            state.viewDP.load = true;
            if (stateChart.data.dataTabel) {
                await stateChart.initOrig.rendering(stateChart, state.viewDP.nowChart, state.viewDP.dom);
            } else {
                state.viewDP.noData = true;
            }
            setTimeout(() => {
                state.viewDP.load = false;
            }, 300)
        },
        //多维分析 切换图表
        async viewDPRenderBefore({
            commit,
            state
        }) {
            let stateChart = state.viewDP.chart;
            await stateChart.initOrig.renderBefore(stateChart, state.viewDP.nowChart, state.viewDP.dom);
        },
        //多维分析 获取保存数据
        async viewDPGetDataVal({
            commit,
            state
        }, chartJSON) {
            let stateChart = state.viewDP.chart;
            let setting = chartJSON.setting;
            let nowChart = chartJSON.nowChart;

            let wdParam = await stateChart.initOrig.wdHandle(stateChart.initOrig.option);
            let dlParam = await stateChart.initOrig.dlHandle(stateChart.initOrig.option);
            let params = await stateChart.initOrig.params(stateChart.initOrig.option);

            //度量
            setting.dlList.map(async (item, index) => {
                let dlConfig = JSON.parse(JSON.stringify(state.viewDP.comDLConfig));
                let node = JSON.parse(JSON.stringify(dlParam));
                setting.dlList[index].config = await getDGCopy(dlConfig, item.config);
                setting.dlList[index].params = await getDGCopy(node, item.params);
            });
            //维度
            setting.wdList.map(async (item, index) => {
                let wdConfig = JSON.parse(JSON.stringify(state.viewDP.comWDConfig));
                let node = JSON.parse(JSON.stringify(wdParam));
                setting.wdList[index].config = await getDGCopy(wdConfig, item.config);
                setting.wdList[index].params = await getDGCopy(node, item.params);
            });
            //筛选
            setting.sxList.map(async (item, index) => {
                let sxConfig = JSON.parse(JSON.stringify(state.viewDP.comSXConfig));
                setting.sxList[index].config = await getDGCopy(sxConfig, item.config);
            });
            setting.xzList.map(async (item, index) => {
                let xzConfig = JSON.parse(JSON.stringify(state.viewDP.comXZConfig));
                setting.xzList[index].config = await getDGCopy(xzConfig, item.config);
            });
            //参数
            let paramsNode = JSON.parse(JSON.stringify(params));
            setting.params = JSON.parse(JSON.stringify(await getDGCopy(paramsNode, setting.params)));
            //全局参数
            let NoChartNode = JSON.parse(JSON.stringify(state.viewDP.nowChart));
            state.viewDP.nowChart = JSON.parse(JSON.stringify(await getDGCopy(NoChartNode, nowChart)));
            stateChart.setting.wdList = setting.wdList;
            stateChart.setting.dlList = setting.dlList;
            stateChart.setting.sxList = setting.sxList;
            stateChart.setting.xzList = setting.xzList;
            stateChart.setting.params = setting.params;


        },
        //多维分析 快照渲染
        async viewDPSnapshot({
            commit,
            state
        }, {
            modu,
            nodeData
        }) {
            let charts = modu[nodeData.chartType];

            if (!charts) {
                return;
            }

            let requestJson = JSON.parse(nodeData.requestJson);
            let dataParam = {};
            charts.chilCharts.map((item) => {
                if (item.name === nodeData.name) {
                    dataParam = item;
                }
            });
            //维度参数 默认
            let wdParamsNow = JSON.parse(JSON.stringify(await charts.wdHandle(charts.option)));
            let wdParams = await getDGCopy(wdParamsNow, dataParam.wdParam);
            //度量参数 默认
            let dlParamsNow = JSON.parse(JSON.stringify(await charts.dlHandle(charts.option)));
            let dlParams = await getDGCopy(dlParamsNow, dataParam.dlParam);

            let setting = JSON.parse(JSON.stringify(requestJson.setting));
            let nowChart = JSON.parse(JSON.stringify(requestJson.nowChart));
            //基本参数
            let paramsNow = JSON.parse(JSON.stringify(await charts.params(charts.option)));
            setting.params = await getDGCopy(paramsNow, setting.params);
            let comConfigNow = JSON.parse(JSON.stringify(state.viewDP.nowChart.comConfig));
            nowChart.comConfig = await getDGCopy(comConfigNow, nowChart.comConfig);

            //维度
            for (let item of setting.wdList) {
                item.params = await getDGCopy(wdParams, item.params);
            }
            //度量
            for (let item of setting.dlList) {
                item.params = await getDGCopy(dlParams, item.params);
            }


            let stateChart = {
                setting: setting,
                option: charts.option,
                initOrig: charts,
                data: JSON.parse(nodeData.returnData),
            };
            let dom = document.getElementById('snap_shot_' + nodeData.id);
            await stateChart.initOrig.rendering(stateChart, nowChart, dom);
        },
        //清空多维分析vuex
        async clearViewDP({
            commit,
            state,
            dispatch
        }) {
            state.viewDP = {
                //当前图表
                nowChart: {
                    type: '',
                    name: '',
                    //公共参数
                    comConfig: {
                        valLength: 50,
                        //图表名称
                        chartName: '',
                        //0 普通 1 圆形 2 其他
                        gridType: 0,
                        //普通
                        grid: {
                            top: 15,
                            bottom: 5,
                            left: 5,
                            right: 5,
                        },
                        //圆
                        circle: {
                            top: 50,
                            left: 50
                        },
                        //颜色组
                        colorIndex: 0,
                        zdy: {
                            chartsTask1: false,
                            chartsUpdateFrequency1: 0,
                            chartsAnimationDuration: 0,
                            chartsTask2: false,
                            chartsUpdateFrequency2: 0,
                        }
                    },
                },
                //缓冲
                load: false,
                //暂无数据
                noData: true,
                //图表
                chart: {
                    //自定义参数
                    setting: {
                        //维度参数
                        wdList: [],
                        //度量参数
                        dlList: [],
                        //筛选参数
                        sxList: [],
                        //下钻参数
                        xzList: [],
                        //参数
                        params: {}
                    },
                    //图表配置
                    option: {},
                    //保存的整体对象
                    initOrig: {},
                    //自定义图表
                    comp: {
                        show: false,
                        component: null
                    },
                    //接口返回数据
                    data: {},
                },
                //dom元素地址
                dom: null,
                //默认全局维度参数
                comWDConfig: {
                    order: '默认',
                    alias: '',
                    calc: '默认'
                },
                //默认全局度量参数
                comDLConfig: {
                    order: '默认',
                    alias: '',
                    calc: '默认'
                },
                //默认全局筛选参数
                comSXConfig: {
                    //空值
                    nullVal: 1,
                    /* - - - - - - - 日期 - - - - - -*/
                    //是否进行过 日期 接口逻辑
                    datebool: false,
                    //时间筛选
                    timDate: [],
                    //离散时间
                    disDateType: '默认',
                    //离散时间 选中的数组
                    disDateCheck: [],
                    //离散时间 总的数组
                    disDateFil: [{
                        type: '默认',
                        values: []
                    }],
                    /* - - - - - - - 字符 - - - - - -*/
                    //是否进行过 字符串 接口逻辑
                    strbool: false,
                    //常规筛选 总的数组
                    convStrFilList: [],
                    //常规筛选 选中的数组
                    convStrCheck: [],
                    //条件筛选
                    ditStr: [],
                    /* - - - - - - - 数字 - - - - - -*/
                    //是否进行过 数字 接口逻辑
                    numbool: false,
                    //范围筛选
                    ranNum: [0, 100],
                    //范围筛选 起始/终点
                    ranNumSTEN: {
                        start: 0,
                        end: 100
                    },
                    //条件筛选
                    ditNum: [],
                },
            };
        },

        // - - - - - - - - - - - - - - - - - - - - - - 大屏 - - - - - - - - - - - - - - - - - - - - - - - - -//

        // 单图表渲染
        async screenRender({
            commit,
            state,
            dispatch
        }) {
            if (state.designer.chart.dragType === 1) {
                for (let item of state.designer.chartList) {
                    if (item.id === state.designer.chart.id) {
                        item._isError = false;
                        state.designer.chart.data = item.viewDP.returnData;
                        break;
                    }
                }
            }
            await dispatch('screenSaveChart');
            let stateChart = state.designer.chart;
            let dom = document.getElementById(stateChart.domId);
            let nowChart = {
                type: stateChart.type,
                name: stateChart.name,
                comConfig: stateChart.comConfig,
            };
            await stateChart.initOrig.renderBefore(stateChart, nowChart, dom);
            await stateChart.initOrig.rendering(stateChart, nowChart, dom);
        },
        //【JSON更新】渲染大屏
        async screenDataRender({
            commit,
            state,
            dispatch
        }) {
            try {
                for (let item of state.designer.chartList) {
                    if (item.id === state.designer.chart.id) {
                        item._isError = false;
                    }
                }
                let stateChart = state.designer.chart;
                stateChart.setting.wdStyParam = [];
                if (stateChart.setting.wdList.length) {
                    stateChart.setting.wdList.map((item) => {
                        stateChart.setting.wdStyParam.push(item.params);
                    })
                }
                stateChart.setting.dlStyParam = [];
                if (stateChart.setting.dlList.length) {
                    stateChart.setting.dlList.map((item) => {
                        stateChart.setting.dlStyParam.push(item.params);
                    })
                }
                stateChart.setting.dlList = [];
                stateChart.setting.wdList = [];
                stateChart.setting.sxList = [];
                await dispatch('screenValConvert');
                await dispatch('screenRender');
            } catch (e) {
                for (let item of state.designer.chartList) {
                    if (item.id === state.designer.chart.id) {
                        item._isError = true;
                    }
                }
            }
        },
        //综合展现数据转换
        async screenValConvert({
            commit,
            state
        }) {
            let JSONData = state.designer.nowChart.comParam.JSONData;
            let stateChart = state.designer.chart;
            await stateChart.initOrig.JSONRender(JSONData.valData, stateChart, state.designer.nowChart, state.viewDP);
        },
        //切换图表
        async screenSwitchChart({
            commit,
            state,
            dispatch
        }, {
            option,
            charts
        }) {
            let chart = state.designer.chart;
            let chartList = state.designer.chartList;
            let nowChart = state.designer.nowChart;
            let defaultVal = state.designer.defaultVal;
            chartList.map((val, index) => {
                if (val.id === option.id) {
                    val.active = true;
                }
            });
            let dataParam = {};
            charts.chilCharts.map((item) => {
                if (item.name === option.name) {
                    dataParam = item;
                }
            });

            //维度参数 默认
            let wdParamsNow = await charts.wdHandle(charts.option);
            nowChart.comPonent.wdParams = await getDGCopy(wdParamsNow, dataParam.wdParam);
            //度量参数 默认
            let dlParamsNow = await charts.dlHandle(charts.option);
            nowChart.comPonent.dlParams = await getDGCopy(dlParamsNow, dataParam.dlParam);

            let saveOption = option.saveOption;
            let setting = saveOption.setting;
            let comConfig = saveOption.comConfig;
            let JSONData = saveOption.JSONData;
            //基本参数
            let paramsNow = await charts.params(charts.option);
            let setParams = await getDGCopy(paramsNow, setting.params);
            setting.params = setParams;
            let comConfigNow = JSON.parse(JSON.stringify(defaultVal.comConfig));
            comConfig = await getDGCopy(comConfigNow, comConfig);

            chart.id = option.id;
            chart.type = option.type;
            chart.name = option.name;
            chart.dragType = option.dragType;
            chart.setting = setting;
            chart.domId = 'screen_dom_' + option.id;
            chart.option = charts.option;
            chart.initOrig = charts;
            chart.data = {};
            //默认配置项
            nowChart.config.wdConfig = false;
            nowChart.config.dlConfig = false;
            nowChart.config.JSONConfig = false;
            nowChart.config.comConfig = false;
            nowChart.config.borderConfig = false;
            if (charts.option.isWdConfig) {
                nowChart.config.wdConfig = true;
            }
            if (charts.option.isDlConfig) {
                nowChart.config.dlConfig = true;
            }
            if (chart.dragType !== 1) {
                if (charts.option.isJSONConfig) {
                    nowChart.config.JSONConfig = true;
                }
            } else {
                chart.data = option.viewDP.returnData;
            }
            if (charts.option.isComConfig) {
                nowChart.config.comConfig = true;
            }
            chart.comConfig = comConfig;
            if (!chart.option.isComBorder) {
                chart.comConfig.border.show = false;
            } else {
                nowChart.config.borderConfig = true;
            }
            charts.configModule.map((item) => {
                item.show = true;
            });
            let moduleList = charts.configModule;
            if (dataParam.isNoModuleName) {
                dataParam.isNoModuleName.map((item) => {
                    moduleList.map((node, index) => {
                        if (item === node.name) {
                            node.show = false;
                        }
                    })
                });
            }
            nowChart.comPonent.component = moduleList;
            nowChart.comPonent.wdComponent = charts.wdComponent;
            nowChart.comPonent.dlComponent = charts.dlComponent;
            nowChart.comPonent.jsonComponent = charts.JSONData.jsonPonent;
            if (nowChart.config.JSONConfig && option.dragType !== 1) {
                let JSONDataNow = JSON.parse(JSON.stringify(defaultVal.JSONData));
                let chartSJSONData = JSON.parse(JSON.stringify(charts.JSONData.params));
                JSONDataNow.params = await getDGCopy(chartSJSONData, JSONData.params);
                nowChart.comParam.JSONData = await getDGCopy(JSONDataNow, JSONData);
                state.designer.updParam.JSONData = JSON.parse(JSON.stringify(nowChart.comParam.JSONData));
            }
        },
        //保存当前图表
        async screenSaveChart({
            commit,
            state,
            dispatch
        }) {
            if (!state.designer.chart.id) {
                return;
            }
            let chartList = state.designer.chartList;
            let saveData = await dispatch('screenSaveData');
            //替换保存的参数
            for (let item of chartList) {
                if (item.id === state.designer.chart.id) {
                    item.active = true;
                    item.saveOption = saveData;
                    break;
                }
            }
        },
        //保存option数据
        async screenSaveData({
            commit,
            state
        }) {
            let chart = state.designer.chart;
            let JSONData = state.designer.nowChart.comParam.JSONData;
            return {
                //JSON
                JSONData: JSONData,
                //公共配置参数
                comConfig: chart.comConfig,
                //自定义参数
                setting: chart.setting
            }
        },
        //保存渲染时数据
        async renderSaveChart({
            commit,
            state,
            dispatch
        }, chart) {
            if (!chart.id) {
                return;
            }
            let chartList = state.designer.chartList;
            //替换保存的参数
            for (let item of chartList) {
                if (item.id === chart.id) {
                    item.saveOption.setting = JSON.parse(JSON.stringify(chart.setting));
                    break;
                }
            }
        },
        //多图表渲染
        async screenAllRender({
            commit,
            state,
            dispatch
        }, {
            modu,
            node
        }) {
            state.designer.chartList = [];
            let list = [];
            node.child.map((item) => {
                try {
                    let requestJson = JSON.parse(item.requestJson);
                    let count = 0;
                    list.map((node) => {
                        if (node.id === requestJson.id) {
                            count = 1;
                        }
                    });
                    if (count === 0) {
                        list.push(JSON.parse(item.requestJson))
                    }
                } catch (e) {

                }
            });
            let defaultVal = state.designer.defaultVal;
            list.map((item, index) => {
                let charts = modu[item.type];
                // item.trans.z = index + 1;
                item._isError = false;
                // item.trans.isNoDrag = false;
                if (charts.component) {
                    item.component = charts.component;
                }
                if (typeof item.saveOption === 'string') {
                    item.saveOption = JSON.parse(item.saveOption);
                }
            });
            state.designer.chartList = list;
            for (let item of state.designer.chartList) {
                let saveCharts = item.saveOption;
                let setting = saveCharts.setting;
                let comConfig = saveCharts.comConfig;
                let comConfigNow = defaultVal.comConfig;
                comConfig = await getDGCopy(comConfigNow, comConfig);
                let JSONData = saveCharts.JSONData;
                let charts = modu[item.type];
                let dataParam = {};
                charts.chilCharts.map((item) => {
                    if (item.name === item.name) {
                        dataParam = item;
                    }
                });
                let nowChart = JSON.parse(JSON.stringify(state.designer.nowChart));
                //维度参数 默认
                let wdParamsNow = await charts.wdHandle(charts.option);
                nowChart.comPonent.wdParams = getDGCopy(wdParamsNow, dataParam.wdParam);
                //度量参数 默认
                let dlParamsNow = await charts.dlHandle(charts.option);
                nowChart.comPonent.dlParams = await getDGCopy(dlParamsNow, dataParam.dlParam);
                //基本参数
                let paramsNow = await charts.params(charts.option);
                setting.params = await getDGCopy(paramsNow, setting.params);
                for (let nod of setting.wdList) {
                    nod.params = await getDGCopy(nowChart.comPonent.wdParams, nod.params);
                }
                for (let nod of setting.dlList) {
                    nod.params = await getDGCopy(nowChart.comPonent.dlParams, nod.params);
                }
                let chart = {
                    //id
                    id: item.id,
                    //图表类型
                    type: item.type,
                    //图表类型名称
                    name: item.name,
                    //自定义参数
                    setting: setting,
                    //保存的整体对象
                    initOrig: charts,
                    //图表配置
                    option: charts.option,
                    //dom元素地址
                    domId: 'screen_dom_' + item.id,
                    //接口返回数据
                    data: {},
                    //公共参数
                    comConfig: comConfig,
                };

                let JSONDataNow = JSON.parse(JSON.stringify(defaultVal.JSONData));
                let DGCopyJSON = await getDGCopy(JSONDataNow, JSONData);
                if (item.dragType !== 1) {
                    let chartSJSONData = JSON.parse(JSON.stringify(charts.JSONData.params));
                    DGCopyJSON.params = await getDGCopy(chartSJSONData, DGCopyJSON.params);
                    if (DGCopyJSON.type === 0) {
                        let countJSON = 0;
                        item._load = true;
                        if (!DGCopyJSON.apiData.url) {
                            countJSON = 1;
                        } else {
                            try {
                                if (DGCopyJSON.apiData.type === 'post') {
                                    if (DGCopyJSON.apiData.postType === 1) {
                                        if (DGCopyJSON.apiData.post) {
                                            let post = JSON.parse(DGCopyJSON.apiData.post);
                                        }
                                    }
                                }
                            } catch (e) {
                                countJSON = 1;
                            }
                            try {
                                if (DGCopyJSON.apiData.headerShow) {
                                    if (DGCopyJSON.apiData.header) {
                                        let header = JSON.parse(DGCopyJSON.apiData.header);
                                    } else {
                                        DGCopyJSON.apiData.header = '';
                                    }
                                }
                            } catch (e) {
                                countJSON = 1;
                            }
                        }
                        if (countJSON === 0) {
                            getParamAPI(DGCopyJSON.apiData).then(res => {
                                try {
                                    let data = JSON.parse(JSON.stringify(res));
                                    DGCopyJSON.valData = JSON.stringify(data, null, '  ');
                                } catch (e) {
                                    item._isError = true;
                                }
                                item._load = false;
                            }).catch(async e => {
                                item._isError = true;
                                item._load = false;
                            });
                        } else {
                            item._load = false;
                        }
                    }
                }
                nowChart.comParam.JSONData = JSON.parse(JSON.stringify(DGCopyJSON));
                item.saveOption = {
                    JSONData: nowChart.comParam.JSONData,
                    setting: setting,
                    comConfig: comConfig
                };
                try {
                    if (item.dragType !== 1) {
                        if (charts.option.isJSONConfig) {
                            await chart.initOrig.JSONRender(saveCharts.JSONData.valData, chart, nowChart, state.viewDP);
                        }
                    } else {
                        let returnData = '{}';
                        node.child.map((j) => {
                            if (j.webID === item.id) {
                                returnData = j.returnData;
                            }
                        });
                        chart.data = JSON.parse(returnData);
                        item.viewDP.returnData = chart.data;
                    }
                    let dom = document.getElementById(chart.domId);
                    let nowC = {
                        type: chart.type,
                        name: chart.name,
                        comConfig: chart.comConfig,
                    };
                    await chart.initOrig.renderBefore(chart, nowC, dom);
                    chart.initOrig.rendering(chart, nowC, dom);
                } catch (e) {
                    item._isError = true;
                }
            }
        },
        //清空当前保存的
        screenClear({
            commit,
            state
        }) {
            let chart = state.designer.chart;
            let nowChart = state.designer.nowChart;
            //默认的配置项
            nowChart.config = {
                //维度配置项
                wdConfig: false,
                //度量配置项
                dlConfig: false,
                //json配置项
                JSONConfig: false,
                //公共配置项
                comConfig: false
            };

            //清空组件配置
            nowChart.comPonent = {
                component: [],
                wdComponent: null,
                dlComponent: null,
                jsonComponent: null,
                wdParams: {},
                dlParams: {},
            };
            //基本图表
            chart.id = '';
            chart.type = '';
            chart.name = '';
            chart.setting = {
                //维度参数
                wdList: [],
                //度量参数
                dlList: [],
                //维度样式参数
                wdStyParam: [],
                //度量样式参数
                dlStyParam: [],
                //筛选参数
                sxList: [],
                //参数
                params: {},
            };
            chart.option = {};
            chart.domId = null;
            chart.data = {};
            chart.comConfig = {};
            chart.initOrig = {};
            chart.dragType = '';
            //JSON
            nowChart.comParam.JSONData = {};
            let chartList = state.designer.chartList;
            for (let item of chartList) {
                item.active = false;
            }
        },
        //清空所有的设计器vuex
        async clearDesigner({
            commit,
            state,
            dispatch
        }) {
            await dispatch('screenClear');
            state.designer.nowChart.config = {
                //维度配置项
                wdConfig: false,
                //度量配置项
                dlConfig: false,
                //json配置项
                JSONConfig: false,
                //公共配置项
                comConfig: false,
                //边框配置项
                borderConfig: false,
            };
            if (state.designer.chartList.length) {
                for (let item of state.designer.chartList) {
                    item = JSON.stringify(item)
                }
            }
            state.designer.chartList = [];
            state.designer.groupDpList = [];
        },


        // - - - - - - - - - - - - - - - - - - - - - - 消息 - - - - - - - - - - - - - - - - - - - - - - - - -//

        //消息弹框
        setNewsShow({
            commit,
            state
        }) {
            state.news.show = !state.news.show
        }
    },
})